<template>
    <div class="person-config">
        <el-row>
            <el-col :span="3">
                <div style="width: 120px;">电脑名称:</div>
            </el-col>
            <el-col :span="21">
                <el-input v-model="personConfig.pcName" style="width: 100%;"></el-input> 
            </el-col>

        </el-row>
        <el-row style="margin-top: 15px;">
            <el-col :span="3">
                <div style="width: 120px">保存日志:</div>
            </el-col>
            <el-col :span="9">
                <el-select v-model="personConfig.saveLog" placeholder="请选择" @change="changeSaveLog" style="width: 100%">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="3" >
                <div style="width: 120px;margin-left: 25px;">铃声选项:</div>
            </el-col>
            <el-col :span="9" >
                <el-select v-model="personConfig.ringOrder" placeholder="请选择" @change="changeOrder" style="width: 100%">
                    <el-option
                    v-for="item in ringOrder"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>

        <div class="section" style="margin-top: 5px;"> 通讯录配置 <el-button @click="personConfig.showPersonList=!personConfig.showPersonList" type="text">{{!personConfig.showPersonList?'展开/编辑':'收缩'}}</el-button></div>
        <el-table stripe border v-if="personConfig.showPersonList" :data="personConfig.personList" style="width: 100%">
            <el-table-column label="姓名" width="100">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.name" :disabled="scope.row.name=='当前用户'"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="手机号" width="130">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.phone" :disabled="scope.row.name=='当前用户'"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="个人微信" >
                <template slot-scope="scope">
                    <el-input v-model="scope.row.wechat" disabled>
                        <el-button slot="append" icon="el-icon-edit" @click="bindWx(scope.row)" >点击绑定</el-button>
                    </el-input>
                </template>
            </el-table-column>
            <el-table-column label="企业微信" width="130">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.workChat" placeholder="联系客服添加"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="120"> 
                <template slot-scope="scope"> 
                    <el-button type="danger"  icon="el-icon-delete" @click="delPerson(scope.$index)" round :disabled="scope.row.name=='当前用户'"></el-button>
                    <el-button type="success" icon="el-icon-plus"   @click="addPerson" round></el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="section">班次配置 <el-button @click="personConfig.showWorkTimeSet=!personConfig.showWorkTimeSet" type="text">{{!personConfig.showWorkTimeSet?'展开/编辑':'收缩'}}</el-button></div>
        <el-table stripe border :data="personConfig.workTimeSet" v-if="personConfig.showWorkTimeSet" >"> 
            <el-table-column label="开始时间" width="180"> 
                <template slot-scope="scope"> 
                    <el-time-picker v-model="scope.row.startTime" value-format="HH:mm:ss" placeholder="" style="width: 150px;"></el-time-picker> 
                </template> 
            </el-table-column>
            <el-table-column label="结束时间" width="180"> 
                <template slot-scope="scope"> 
                    <el-time-picker v-model="scope.row.endTime" value-format="HH:mm:ss" placeholder=""   style="width: 150px;"></el-time-picker> 
                </template> 
            </el-table-column>
            <el-table-column label="班次名称" > 
                <template slot-scope="scope"> 
                    <el-input v-model="scope.row.name" placeholder="请输入班次名称" :disabled="1==1"></el-input>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="微信绑定" :visible.sync="showBindQr" @close="queryUserInfo" :modal="false">
            <div style="display: flex;width: 100%;align-items: center;justify-content: center;">
                <div style="width: 200px;height: 200px;border: #ccc 1px solid;line-height: 200px;" >
                    <img :src="bindQr" alt="QR Code"  style="width: 100%; height: 100%;border: 1px solid #ccc;" v-if="bindQr"/>
                </div>
            </div>
            
        </el-dialog>
    </div>
</template>

<script>
import QRCode from 'qrcode'; // 引入 qrcode 库
    export default {
        name: 'PersonConfig',
        props: {
            personal: Object,
        },
        beforeDestroy() {
            
        },
        data() {
            return {
                bindQr: '',
                showBindQr: false,
                personConfig:{
                    showWorkTimeSet: true,
                    showPersonList: true,
                    pcName:'默认电脑1',
                    workTimeSet:[{name:'默认班次',startTime:'00:00:00',endTime:'23:59:59'},{name:'白班',startTime:'08:00:00',endTime:'17:00:00'},{name:'夜班',startTime:'23:00:00',endTime:'08:00:00'}],
                    personList:[],
                    saveLog:"0"
                },
                options: [{
                value: '0',
                label: '不保存'
                }, {
                value: '1',
                label: '保存日志-仅提醒'
                }, {
                value: '2',
                label: '保存日志-所有'
                }, {
                value: '3',
                label: '保存调试日志'
                }],
                ringOrder: [{
                    value: '0',
                    label: '遇忙忽略'
                }, {
                    value: '1',
                    label: '遇忙排队'
                }],
                
            }
        },
        mounted() {
            this.personConfig=this.personal
        },
        created() {

        },
        methods: {
            changeSaveLog(value){
                console.log('changeSaveLog',value)
                let version=localStorage.getItem('version')
                if(version<5.01){
                    this.$message.error('保存日志功能需要5.01及以上版本才能使用，请前往官网更新到最新版本')
                }
            },
            changeOrder(value){
                console.log('changeOrder',value)
                let version=localStorage.getItem('version')
                if(version<5.02){
                    this.$message.error('铃声选项功能需要5.02及以上版本才能使用，请前往官网更新到最新版本')
                }
            },
            addTimeSet(){
                this.personConfig.workTimeSet.push({name:'',start:'',end:''})
            },
            addPerson(){
                this.personConfig.personList.push({name:'',tel:'',wechat:'',workChat:''})
            },
            delTimeSet(index){ 
                console.log(index)
                this.personConfig.workTimeSet.splice(index,1)
            },
            delPerson(index){ 
                console.log(index)
                this.personConfig.personList.splice(index,1)
            },
            bindWx(row){
                console.log(row)
                let arr=[]
                for(let i in this.personConfig.personList){
                   let name=this.personConfig.personList[i].name
                   if(arr.indexOf(name)!=-1){
                    this.$message.error('联系人中存在重复的姓名，请修改后再绑定')
                    return
                   }else{
                    arr.push(name)
                   }
                }

                this.showBindQr=true
  
                
                this.$post('/api/v9/getBindQr',{nickName:row.name}).then(res=>{
                    console.log(res)
                    if(res.code==1){
                        QRCode.toDataURL(res.qrCode, (err, url) => {
                            if (err) {
                            console.error('生成二维码失败:', err);
                            this.$message({
                                message: '生成二维码失败',
                                type: 'error'
                            });
                            return;
                            }
                            this.bindQr = url;
                        });

                    }else{
                        this.$message.error('获取二维码失败')
                    }
                })
            
            },
            queryUserInfo(){
                console.log('queryUserInfo')
                this.$post('/api/v9/queryUserInfo',{}).then(res=>{
                    console.log(res)
                    let wechatInfo=res.wechatInfo
                    let personList=JSON.parse(JSON.stringify(this.personConfig.personList))
                    for(let i in wechatInfo){
                        for (let j in personList){
                            console.log(personList[j].name,wechatInfo[i].nickName)
                            if(personList[j].name==wechatInfo[i].nickName){
                                personList[j].wechat=wechatInfo[i].openid
                            }
                        }
                    }
                    this.personConfig.personList=personList

                })
            }
        }
}


</script>

<style  scoped>
.person-config {
    display: flex;   
    flex-direction: column;
}
.section {
    margin-top: 20px;
}
</style>